import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowRotateLeft,
  faChartBar,
  faDatabase,
  faFileArrowUp,
  faFileInvoice,
  faMagnifyingGlass,
  faScaleBalanced,
  faTrash,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { TranslationKeys } from '../../../../translations';

export type AdminFeature = {
  titleId: string;
  descriptionId: string;
  link: string;
  icon: IconDefinition;
  comingSoon?: boolean;
};

export type AdminCategory = {
  titleId: string;
  tabIcon: IconDefinition;
  color: string;
  features: AdminFeature[];
};

export const CATEGORIES: AdminCategory[] = [
  {
    titleId: TranslationKeys.adminPanel_category_inspectionDiagnostics,
    tabIcon: faMagnifyingGlass,
    color: '#00A0FF',
    features: [
      {
        titleId: TranslationKeys.menu_adminPanel_connectionInspector,
        descriptionId: TranslationKeys.adminPanel_feature_connectionInspector_description,
        link: '/admin-panel/connection-inspector',
        icon: faMagnifyingGlass,
      },
      {
        titleId: TranslationKeys.menu_adminPanel_databaseInspector,
        descriptionId: TranslationKeys.adminPanel_feature_databaseInspector_description,
        link: '/admin-panel/database-inspector',
        icon: faDatabase,
        comingSoon: true,
      },
      {
        titleId: TranslationKeys.menu_adminPanel_nmbrsComparator,
        descriptionId: TranslationKeys.adminPanel_feature_nmbrsComparator_description,
        link: '/admin-panel/nmbrs-comparator',
        icon: faScaleBalanced,
        comingSoon: true,
      },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_category_dataRecovery,
    tabIcon: faArrowRotateLeft,
    color: '#40C484',
    features: [
      {
        titleId: TranslationKeys.menu_adminPanel_restoreConnections,
        descriptionId: TranslationKeys.adminPanel_feature_restoreConnections_description,
        link: '/admin-panel/restore-connections',
        icon: faArrowRotateLeft,
      },
      {
        titleId: TranslationKeys.menu_adminPanel_undoUploadedFile,
        descriptionId: TranslationKeys.adminPanel_feature_undoUploadedFile_description,
        link: '/admin-panel/undo-uploaded-file',
        icon: faTrash,
      },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_category_operations,
    tabIcon: faFileArrowUp,
    color: '#F3AE43',
    features: [
      {
        titleId: TranslationKeys.menu_adminPanel_naverrekenenTemplateUpload,
        descriptionId: TranslationKeys.adminPanel_feature_naverrekenenTemplateUpload_description,
        link: '/admin-panel/naverrekenen-template',
        icon: faFileArrowUp,
      },
      {
        titleId: TranslationKeys.menu_adminPanel_bulkLeftCompany,
        descriptionId: TranslationKeys.adminPanel_feature_bulkLeftCompany_description,
        link: '/admin-panel/bulk-left-company',
        icon: faUsers,
      },
    ],
  },
  {
    titleId: TranslationKeys.adminPanel_category_analyticsReporting,
    tabIcon: faChartBar,
    color: '#7C4DFF',
    features: [
      {
        titleId: TranslationKeys.menu_adminPanel_stats,
        descriptionId: TranslationKeys.adminPanel_feature_stats_description,
        link: '/admin-panel/stats',
        icon: faChartBar,
        comingSoon: true,
      },
      {
        titleId: TranslationKeys.menu_adminPanel_productInvoicing,
        descriptionId: TranslationKeys.adminPanel_feature_productInvoicing_description,
        link: '/admin-panel/product-invoicing',
        icon: faFileInvoice,
        comingSoon: true,
      },
    ],
  },
];
